<template>
  <v-app>
    <!-- Laptop view -->
    <v-main class="hidden-md-and-down">
      <v-row>
        <v-col cols="12" md="1" sm="1" lg="1">
          <NavMenu />
        </v-col>
        <v-spacer />
        <v-col cols="12" md="10" sm="10" lg="10">
          <v-window v-model="step">
            <v-window-item :value="1">
              <v-container>
                <div style="margin:30px 110px 30px 110px">
                  <div style="max-width:100%">
                    <span
                      class="font-weight-bold"
                      style="padding-top:3px;text-decoration:none;font-size:24px"
                    >
                      Subscribers</span
                    >

                    <v-badge
                      small
                      overlap
                      style="float:right;margin-top:5px;margin-right:34px"
                      color="red"
                      class="pulsing"
                      :content="notifications.length"
                      :value="notifications.length"
                    >
                    </v-badge>
                    <v-btn to="/notifications" style="float:right" icon
                      ><v-icon>mdi-bell-outline</v-icon></v-btn
                    >
                  </div>
                  <div style="margin-top:30px">
                    <p style="text-align:end;margin-bottom:17px">
                      <v-btn
                        x-large
                        color="red"
                        class="white--text"
                        @click="messageAll()"
                        ><v-icon class="mr-2">mdi-email</v-icon>Email all
                        subscribers</v-btn
                      >
                    </p>
                    <div style="margin-top:20px">
                      <v-text-field
                        v-model="search"
                        outlined
                        append-icon="mdi-magnify"
                        color="#e50914"
                        style="border-radius:14px"
                        label="Search Subscribers by Name"
                      />
                    </div>
                    <v-list v-if="!loading">
                      <v-list-item v-for="(user, i) in filteredUsers" :key="i">
                        <v-list-item-avatar>
                          <v-btn
                            color="red"
                            class="white--text"
                            fab
                            depressed
                            >{{ user.name.slice(0, 2) }}</v-btn
                          >
                        </v-list-item-avatar>
                        <v-list-item-content>
                          {{ user.name }}
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            @click="sendEmail(user.email, user.name)"
                            outlined
                            color="red"
                            class="white--text"
                            >Email</v-btn
                          >
                        </v-list-item-action>
                        <v-list-item-action>
                          <v-btn
                            color="black"
                            @click="deleteUser(user)"
                            small
                            icon
                            ><v-icon color="black">mdi-delete</v-icon></v-btn
                          >
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                    <v-list v-if="loading">
                      <v-skeleton-loader type="list-item-avatar-two-line">
                      </v-skeleton-loader>
                      <v-skeleton-loader type="list-item-avatar-two-line">
                      </v-skeleton-loader>
                      <v-skeleton-loader type="list-item-avatar-two-line">
                      </v-skeleton-loader>
                      <v-skeleton-loader type="list-item-avatar-two-line">
                      </v-skeleton-loader>
                      <v-skeleton-loader type="list-item-avatar-two-line">
                      </v-skeleton-loader>
                    </v-list>
                  </div>
                </div>
              </v-container>
            </v-window-item>
            <v-window-item :value="2" class="px-5">
              <template>
                <v-btn @click="step--" text class="mt-3" style="float:right"
                  ><v-icon>mdi-close</v-icon></v-btn
                >
                <div style="padding:50px">
                  <h3 class="font-weight-bold mb-6">
                    Send an email to <span style="color:red">{{ name }}</span>
                  </h3>
                  <label>Recipient</label>
                  <v-text-field
                    color="red"
                    solo
                    label="Recipient"
                    readonly
                    v-model="name"
                  />
                  <v-text-field
                    color="red"
                    outlined
                    label="Email Title"
                    v-model="title"
                  />
                  <label>Email Body</label>
                  <tiptap @emailContent="emailContent" id="emailBody" />
                  <p
                    style="position:fixed;margin:0px 70px 70px 0px;bottom:0;font-size:10px;text-decoration:italics"
                  >
                    Hint:"Use {name} to refer to your recipient in your email
                    body"
                  </p>
                  <v-btn
                    @click="submitEmail()"
                    large
                    color="red"
                    style="margin:70px;position:fixed;right:0;bottom:0"
                    class="white--text"
                    >Send Email</v-btn
                  >
                </div>
              </template>
            </v-window-item>
            <v-window-item :value="3" class="px-5">
              <v-btn @click="step = 1" text class="mt-3" style="float:right"
                ><v-icon>mdi-close</v-icon></v-btn
              >
              <div style="padding:50px">
                <h3 class="font-weight-bold mb-6">
                  Send an email to
                  <span style="color:red">all your Subscribers</span>
                </h3>
                <v-text-field
                  color="red"
                  outlined
                  label="Email Title"
                  v-model="title"
                />
                <label>Email Body</label>
                <tiptap @emailContent="emailContent" id="emailBody" />
                <p
                  style="position:fixed;margin:0px 70px 70px 0px;bottom:0;font-size:10px;text-decoration:italics"
                >
                  Hint:"Use {name} to refer to your recipient in your email
                  body"
                </p>
                <v-btn
                  @click="submitEmailAll()"
                  large
                  color="red"
                  style="margin:70px;position:fixed;right:0;bottom:0"
                  class="white--text"
                  >Send Email</v-btn
                >
              </div>
            </v-window-item>
          </v-window>
        </v-col>
      </v-row>
    </v-main>

    <!-- Phone view -->
    <v-main class="hidden-lg-and-up pt-5">
      <v-window v-model="step">
        <v-window-item :value="1">
          <v-container class="pa-6">
            <span
              class="font-weight-bold"
              style="padding-top:0px;text-decoration:none;font-size:20px"
            >
              Subscribers</span
            >
            <v-badge
              small
              overlap
              dot
              :content="notifications.length"
              :value="notifications.length"
              style="float:right;margin-top:5px;margin-right:34px"
              color="red"
              class="pulsing"
            >
            </v-badge>
            <v-btn to="/notifications" small style="float:right" icon
              ><v-icon>mdi-bell-outline</v-icon></v-btn
            >

            <div style="margin-top:30px;margin-bottom:39px">
              <p style="text-align:end;margin-bottom:17px">
                <v-btn
                  large
                  color="red"
                  class="white--text"
                  @click="messageAll()"
                  ><v-icon class="mr-2">mdi-email</v-icon>Email all
                  subscribers</v-btn
                >
              </p>
              <div style="margin-top:20px">
                <v-text-field
                  v-model="search"
                  outlined
                  append-icon="mdi-magnify"
                  color="#e50914"
                  style="border-radius:14px"
                  label="Search Subscribers by Name"
                />
              </div>

              <v-list v-if="!loading">
                <v-list-item v-for="(user, i) in filteredUsers" :key="i">
                  <v-list-item-avatar>
                    <v-btn fab color="red" class="white--text">{{
                      user.name.slice(0, 2)
                    }}</v-btn>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    {{ user.name }}
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      x-small
                      fab
                      outlined
                      color="red"
                      @click="sendEmail(user.email, user.name)"
                      ><v-icon>mdi-email</v-icon></v-btn
                    >
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn
                      x-small
                      @click="deleteUser(user)"
                      color="black"
                      icon
                      ><v-icon>mdi-delete</v-icon></v-btn
                    >
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-list v-if="loading">
                <v-skeleton-loader type="list-item-avatar-two-line">
                </v-skeleton-loader>
                <v-skeleton-loader type="list-item-avatar-two-line">
                </v-skeleton-loader>
                <v-skeleton-loader type="list-item-avatar-two-line">
                </v-skeleton-loader>
                <v-skeleton-loader type="list-item-avatar-two-line">
                </v-skeleton-loader>
                <v-skeleton-loader type="list-item-avatar-two-line">
                </v-skeleton-loader>
              </v-list>
            </div>
          </v-container>
        </v-window-item>
        <v-window-item :value="2">
          <v-btn @click="step = 1" text class="mt-3" style="float:right"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <div style="padding:50px">
            <h3 class="font-weight-bold mb-6">
              Send an email to <span style="color:red">{{ name }}</span>
            </h3>
            <label>Recipient</label>
            <v-text-field
              color="red"
              solo
              label="Recipient"
              readonly
              v-model="name"
            />
            <v-text-field
              color="red"
              outlined
              label="Email Title"
              v-model="title"
            />
            <label>Email Body</label>
            <div style="margin-bottom:130px">
              <tiptap @emailContent="emailContent" id="emailBody" />
            </div>

            <v-btn
              @click="submitEmail()"
              large
              color="red"
              style="margin:130px 70px 0px 70px;position:fixed;right:0;bottom:0"
              class="white--text"
              >Send Email</v-btn
            >
            <!-- <p style="position:absolute:bottom:10px;font-size:10px;text-decoration:italics">Hint:"Use {name} to refer to your recipient in your email body"</p> -->
          </div>
        </v-window-item>

        <v-window-item :value="3">
          <v-btn @click="step = 1" text class="mt-3" style="float:right"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <div style="padding:50px">
            <h3 class="font-weight-bold mb-6">
              Send an email to
              <span style="color:red">all your Subscribers</span>
            </h3>
            <v-text-field
              color="red"
              outlined
              label="Email Title"
              v-model="title"
            />
            <label>Email Body</label>
            <tiptap @emailContent="emailContent" id="emailBody" />
            <p
              style="margin:140px 70px 10px 70px;position:fixed;right:0;bottom:50px;font-size:10px;text-decoration:italics"
            >
              Hint:"Use {name} to refer to your recipient in your email body"
            </p>
            <v-btn
              @click="submitEmailAll()"
              large
              color="red"
              style="margin:130px 70px 10px 70px;position:fixed;right:0;bottom:0"
              class="white--text"
              >Send Email</v-btn
            >
          </div>
        </v-window-item>
      </v-window>
    </v-main>
    <BottomMenu class="hidden-lg-and-up" v-if="step == 1" />
    <v-dialog width="500px" style="margin:auto" v-model="deleteuser">
      <v-card width="500px" class="createAccount black--text pa-5">
        <p>Are you sure you want to delete {{ name }}'s account?</p>
        <v-btn :loading="btnloading" color="black" @click="yesDelete(slug)" class="white--text mr-5">
          Yes</v-btn
        >
        <v-btn outlined @click="deleteuser = !deleteuser"> No</v-btn>
      </v-card>
    </v-dialog>
    <v-overlay
      style="text-align:center"
      :absolute="absolute"
      opacity="0.7"
      :value="btnloading"
    >
      <v-progress-circular
        :size="80"
        :width="5"
        color="#e50914"
        class="text-center"
        indeterminate
      ></v-progress-circular>
      <p class="text-center">Sending email, please wait...</p>
    </v-overlay>
  </v-app>
</template>

<script>
import Tiptap from "@/components/Index.vue";
import BottomMenu from "@/components/BottomMenu";
import NavMenu from "@/components/NavMenu";
import { mapState, mapGetters } from "vuex";
import db from "../db";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import axios from "axios";
import { doc,updateDoc,arrayRemove } from '@firebase/firestore';
// import moment from "moment";
// import slugify from 'slugify'

export default {
  name: "AdminDashboard",
  components: {
    BottomMenu,
    NavMenu,
    Tiptap
  },

  data() {
    return {
      person: "",
      persons: "",
      search: "",
      deleteuser: false,
      slug: "",
      emailBox: false,
      name: "",
      email: "",
      emailBody: "",
      title: "",
      step: 1,
      btnloading: false,
      absolute: true
    };
  },

  metaInfo: {
    title: "Subscribers",
    titleTemplate: "%s | Tippings ",
    meta: [
      {
        name: "description",
        content: "Seamlessly get rewarded for your creativity on Tippings"
      },
      {
        property: "og:title",
        content: " Subscribers | Tippings"
      },
      { property: "og:site_name", content: "Tippings" },
      {
        property: "og:description",
        content: "Seamlessly get rewarded for your creativity on Tippings"
      },
      { property: "og:type", content: "profile" },
      {
        property: "og:url",
        content: "https://tippings.me"
      },
      { property: "og:image", content: "" }
    ]
  },

  computed: {
    ...mapState({
      loading: "loading",
      userData: "userData",
      walletBalance: "walletBalance",
      activities: "activities",
      bankDetails: "bankDetails",
      subscribers: "subscribers",
      notifications: "notifications",
      username: "username"
    }),
    ...mapGetters({
      user: "user"
    }),

    filteredUsers() {
      const searchUser = this.search.toLowerCase().trim();
      if (!searchUser) return this.subscribers;
      return this.subscribers.filter(
        user => user.name.toLowerCase().indexOf(searchUser) > -1
      );
    }
  },

  async beforeCreate() {
    if (localStorage.getItem("tippingsKey") == null) {
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          this.$router.push("/login");
        })
        .catch(error => {
          console.log(error);
        });
    }
    const auth = getAuth();
    onAuthStateChanged(auth, user => {
      this.person = user;
      if (!user) {
        this.$router.push("/login");
      }
    });

    if (this.subscribers == undefined) {
      await this.$store.dispatch("fetchUserData");
    }
  },

  methods: {
    messageAll() {
      this.step = 3;
    },
    emailContent(e) {
      this.emailBody = e;
    },

    submitEmail() {
      this.btnloading = true;
      axios({
        method: "post",
        url: "https://tips-api.herokuapp.com/mail",
        data: {
          from: this.userData.name + " <support@tippings.me>",
          email: this.email,
          replyTo: this.userData.email,
          title: this.title,
          message: `<div style="margin:0px 30px 0px 30px">
          <div style="text-align:center;width:50%:margin:auto">
          <div style=" text-align: center; width:300px; margin:auto auto 20px auto"> 
          <div style="position: relative;top: 10px;color: white;font-size: 13px;background: white;display: inline-block;padding: 0 20px;border-radius: 30px;">
          <img src=${this.userData.photoURL} width="60px" height="60px" style="width:60px;text-align:center;margin:auto;border-radius:50%"/>
          </div>
          <div style="margin-top:20px;height:1px;background:black"></div>
        </div>
         </div>


          <h2 style="margin-top:20px">Hello ${this.name} 👋🏾</h2>

          ${this.emailBody}
          <div style="border:solid 4px black;background:black,color:${this.userData.btncolor},padding:400px;display:flex">
          <div style="margin-top:60px;background-color: ${this.userData.btncolor}; color: black; text-align: center; padding: 30px 20px 30px 20px;">
          <p style="text-align: center; color: white;">

          <a style="color: #000000;margin-right:15px" href="https://facebook.com/${this.userData.facebook}">
          <img class="alignnone wp-image-28420" src="https://i.ibb.co/FzDN2DT/facebook-1.png" alt="" width="22" height="22" />
          </a>
          
          
          <a style="color: #000000;margin-right:15px" href="https://twitter.com/${this.userData.twitter}">
          <img class="alignnone wp-image-28421" src="https://i.ibb.co/yF5Hq15/twitter-1.png" alt="" width="21" height="21" />
          </a>
          

          <a style="color: #000000;margin-right:15px" href="https://instagram.com/${this.userData.instagram}">
          <img class="alignnone wp-image-28422" src="https://i.ibb.co/HYMFS5D/instagram-1.png" alt="" width="21" height="21" />
          </a>

          
          <a style="color: #000000;margin-right:15px" href="https://linkedin.com/in/${this.userData.linkedin}">
          <img class="alignnone wp-image-28423" src="https://i.ibb.co/nsJMFYn/linkedin-1.png" alt="" width="21" height="21" />
          </a>
          

          <a style="color: #000000;margin-right:15px" href="https://www.youtube.com/${this.userData.youtube}">
          <img class="alignnone wp-image-28424" src="https://i.ibb.co/7121z7Y/youtube.png" alt="" width="21" height="21" />
          </a>

          

          </p>
          </div>


          </div>
          
          </div>`
        }
      })
        .then(response => {
          console.log(response);
          this.btnloading = false;
          this.$swal({
            title: "Email Sent",
            text:
              "Congratulations, Your email has successfully been sent to your subscriber(s)",
            icon: "success",
            confirmButtonText: "Ok"
          });
        })
        .catch(error => {
          console.log(error);
          this.btnloading = false;
          this.$swal({
            title: "Email Not Sent",
            text: "Sorry, we couldn't send your email due to a network error.",
            icon: "error",
            confirmButtonText: "Ok"
          });
        });
    },

    submitEmailAll() {
      this.btnloading = true;
        axios({
          method: "post",
          url: "https://tips-api.herokuapp.com/bulkmail",
          data: {
            from: this.userData.name+" <support@tippings.me>",
            subscribers: this.userData.subscribers,
            userData:this.userData,
            replyTo: this.userData.email,
            title: this.title,
            emailBody:this.emailBody,
          }
        })
          .then(response => {
            console.log(response);
            this.btnloading = false;
            this.$swal({
              title: "Email Sent",
              text:
                "Congratulations, Your email has successfully been sent to your subscriber(s)",
              icon: "success",
              confirmButtonText: "Ok"
            });
          })
          .catch(error => {
            console.log(error);
            this.btnloading = false;
            this.$swal({
              title: "Email Not Sent",
              text:
                "Sorry, we couldn't send your email due to a network error.",
              icon: "error",
              confirmButtonText: "Ok"
            });
          });
    },

    sendEmail(email, name) {
      this.step++;
      this.name = name;
      this.email = email;
    },

    deleteUser(e) {
      console.log(e)
      this.name = e.name;
      this.slug = e;
      this.deleteuser = !this.deleteuser;
    },
    yesDelete(e) {
      console.log(e)
      this.btnloading = true
      let userSlug = localStorage.getItem("tippingsKey")
      const user = doc(db,"users",userSlug)
      updateDoc(user,{
        subscribers: arrayRemove(e)
      })
        .then(() => {
          this.btnloading = false
          this.$swal({
            title:"Success!",
            icon:"success",
            text:"Email subscriber has been deleted successfully!",
            confirmButtonText:"Ok"
          })
          location.reload();
        });
    }
  }
};
</script>

<style scoped>
div.scrollmenu {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 0px 0px 30px 10px;
}

div.scrollmenu .card {
  flex: 0 0 auto;
}

.transborders {
  border: solid 0.1em #eef1f1;
  border-radius: 8px;
  height: 69px;
  margin-bottom: 4px;
}

.calCardMobile {
  background: linear-gradient(180deg, #f5c723 0%, #e6a71b 100%);
}

.pulsing {
  box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.897);
  border-radius: 30px;
  -webkit-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulsing 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  transition: all 300ms ease-in-out;
}

@-webkit-keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}

@-moz-keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}

@-ms-keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}

@keyframes pulsing {
  to {
    box-shadow: 0 0 0 5px rgba(232, 76, 61, 0);
    border-radius: 30px;
  }
}
</style>
